import { render, staticRenderFns } from "./support-image-attachment.vue?vue&type=template&id=374c420a&scoped=true"
import script from "./support-image-attachment.vue?vue&type=script&lang=js"
export * from "./support-image-attachment.vue?vue&type=script&lang=js"
import style0 from "./support-image-attachment.vue?vue&type=style&index=0&id=374c420a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c420a",
  null
  
)

export default component.exports